import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { currentClient, clientVisits, isDesktopAdmin, isAdmin, loading } from '../store/state';
import { Shell } from '../layout/Shell';
import { VisitsTable } from '../components/VisitsTable';
import { eL, fmtC } from '../utils/format';
import { abrirVisita, ensureClientHistorialLoaded } from '../store/actions/visit.actions';
import { eliminarCliente } from '../store/actions/client.actions';
import { Icon } from '../components/Icon';

interface Props {
  id: string;
}

export function ClienteHistorialView({ id }: Props) {
  useEffect(() => {
    ensureClientHistorialLoaded(id);
  }, [id]);

  const cl = currentClient.value;
  const dt = isDesktopAdmin.value;

  if (!cl || cl.id !== id) {
    return <Shell tab="clientes">{!loading.value && <p class="empty">No encontrado.</p>}</Shell>;
  }

  return (
    <Shell tab="clientes">
      <button
        class="secondary"
        style={{ marginBottom: 12, ...(dt ? { width: 'auto', padding: '8px 16px' } : {}) }}
        onClick={() => route('/clientes')}
      >
        <Icon name="arrow-left" size={16} />
        Volver
      </button>
      <div class="card">
        <div class="row">
          <strong>{cl.nombre}</strong>
          <span class={'badge ' + cl.estado}>{eL(cl.estado)}</span>
        </div>
        <p class="muted">
          {cl.direccion || ''}
          {cl.zona ? ' · Zona: ' + cl.zona : ''}
        </p>
        {cl.contactoNombre && (
          <p class="muted">
            {cl.contactoNombre}
            {cl.contactoTelefono ? ' · ' + cl.contactoTelefono : ''}
          </p>
        )}
        <p class="muted">
          {cl.visitasMensuales} visita(s)/mes · Próxima: {fmtC(cl.proximaFechaLimite)}
        </p>
        {cl.notasAcceso && (
          <div
            style={{
              background: 'var(--warning-bg)',
              padding: '8px 12px',
              borderRadius: 8,
              marginTop: 8,
              fontSize: 13,
            }}
          >
            <strong>Notas:</strong> {cl.notasAcceso}
          </div>
        )}
        {isAdmin.value && (
          <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
            <button
              class="secondary"
              style={{ flex: 1, padding: 6, fontSize: 13, marginTop: 0 }}
              onClick={() => route(`/clientes/${cl.id}/editar`)}
            >
              <Icon name="pencil" size={13} />
              Editar
            </button>
            <button
              class="danger-outline"
              style={{ flex: 1, padding: 6, fontSize: 13, marginTop: 0 }}
              onClick={() => eliminarCliente(cl.id)}
            >
              <Icon name="trash-2" size={13} />
              Desactivar
            </button>
          </div>
        )}
      </div>

      <h3 style={{ margin: '16px 0 8px' }}>Historial ({clientVisits.value.length})</h3>
      {clientVisits.value.length ? (
        dt ? (
          <VisitsTable list={clientVisits.value} />
        ) : (
          clientVisits.value.map((v) => (
            <div key={v.id} class="card" style={{ cursor: 'pointer' }} onClick={() => abrirVisita(v.id)}>
              <div class="row">
                <span class={'badge estado-' + v.estado}>{eL(v.estado)}</span>
                <span class="muted">{fmtC(v.fechaProgramada)}</span>
              </div>
              <p class="muted">
                {v.tecnico?.nombre || 'Sin técnico'}
                {v.numeroTicket ? ' · #' + v.numeroTicket : ''}
              </p>
              {v.descripcionTrabajo && (
                <p style={{ fontSize: 13, margin: '4px 0 0' }}>
                  {v.descripcionTrabajo.substring(0, 100)}
                </p>
              )}
            </div>
          ))
        )
      ) : (
        <div class="empty">
          <Icon name="calendar-days" />
          <p>Sin visitas registradas todavía.</p>
        </div>
      )}
    </Shell>
  );
}
